import { FC } from 'react';
import { GrowthRateBasisType, ReferenceData } from '@xplan-pension-switching/common';
import { IressTable } from '@iress-oss/ids-components';
import { growthRateTableColumns } from './GrowthRateTableColumns';
import { useGrowthRateTableData } from '../../../hooks';
import { getEnumKeyByValue } from '../../../helpers';

export const ProjectedGrowthRatesTable: FC<{
    growthRateLow?: number;
    growthRateMid?: number;
    growthRateHigh?: number;
    referenceData: ReferenceData;
    selectedGrowthRateBasisType: GrowthRateBasisType;
    defaultGrowthRateBasisType?: GrowthRateBasisType;
}> = ({
    growthRateLow,
    selectedGrowthRateBasisType,
    growthRateHigh,
    growthRateMid,
    referenceData,
    defaultGrowthRateBasisType,
}) => {
    const { rowData } = useGrowthRateTableData(
        selectedGrowthRateBasisType,
        referenceData,
        defaultGrowthRateBasisType ?? GrowthRateBasisType.IndustryStandard,
        growthRateLow,
        growthRateMid,
        growthRateHigh
    );
    const growthRateBasisTypeName = getEnumKeyByValue(GrowthRateBasisType, selectedGrowthRateBasisType);
    return (
        rowData && (
            <IressTable
                caption={`Projected Growth Rate - ${growthRateBasisTypeName}`}
                className="xps-table"
                columns={growthRateTableColumns}
                data-testid={'fundSpecificInflationTable'}
                hiddenCaption
                scope="col"
                rows={rowData}
            />
        )
    );
};
